import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type CreateWorkflowContext = OpalApi<'CreateContextV2', 201>

export const createWorkflowContext: CreateWorkflowContext = async (
  params = {}
) => {
  const url = new URL('/workflows/v2/contexts', window.location.origin)

  return HttpClient()
    .post(url.toString(), params.requestBody)
    .then((res) => res.data)
}
